app.controller("customPageCtrl", [
  "$scope",
  "$location",
  "getSiteDetails",
  function ($scope, $location, getSiteDetails) {
    if (fullSite.siteAvailable == false) {
      $location.path("/siteUnavailable");
    }

    var customPageElements = [];
    $scope.customPageElements = [];

    var path = $location.path();
    path = path.split("/")[1];
    getSiteDetails
      .getCustomPageElements(fullSite.micrositeID, path, true)
      .then((result) => {
        if (result.content.length > 0) {
          customPageElements = result.content;
          $scope.loadMore(true, true);
        } else {
          $("#404").show();
        }
      })
      .catch((err) => {
        $scope.customPageElements = [];
        $("#404").show();
      });

      $scope.loadMore = (last, inview) => {
        if (customPageElements.length > 0 && last && inview)
          $scope.customPageElements.push(customPageElements.shift());
      };
  },
]);
